import { FileRejection } from 'react-dropzone'
import { Area } from 'react-easy-crop'
import { EnqueueSnackbar } from 'notistack'

export const getCroppedImg = (imageSrc: string, pixelCrop: Area) =>
  new Promise((resolve: (value: Blob) => void, reject) => {
    const image = new Image()
    image.crossOrigin = 'anonymous'
    image.src = imageSrc

    image.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = pixelCrop.width
      canvas.height = pixelCrop.height
      const ctx = canvas.getContext('2d')

      if (!ctx) {
        reject(new Error('Failed to get canvas context'))
        return
      }

      ctx.drawImage(image, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, pixelCrop.width, pixelCrop.height)

      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('Failed to create blob from canvas'))
          return
        }
        resolve(blob)
      }, 'image/jpeg')
    }

    image.onerror = () => reject()
  })

export const handleDrop = ({
  enqueueSnackbar,
  acceptedFiles,
  fileRejections,
  setUploadedPhoto,
}: {
  enqueueSnackbar: EnqueueSnackbar
  acceptedFiles: File[]
  fileRejections: FileRejection[]
  setUploadedPhoto: React.Dispatch<React.SetStateAction<string | null>>
}) => {
  if (fileRejections.length > 0) {
    if (fileRejections[0].errors[0].code === 'file-invalid-type')
      enqueueSnackbar('Invalid file type. Please upload a valid PNG, JPG, or GIF image file.', { variant: 'error' })
    else enqueueSnackbar(`Error uploading file: ${fileRejections[0].errors[0].message}`, { variant: 'error' })
    return
  }

  const file = acceptedFiles[0]
  if (!file) return

  const reader = new FileReader()
  reader.onloadend = () => {
    const base64String = reader.result
    if (base64String) setUploadedPhoto(base64String as string)
  }
  reader.onerror = () => {
    enqueueSnackbar('Error reading file', { variant: 'error' })
  }
  reader.readAsDataURL(file) // Read the file as a data URL
}
